import React from 'react';
import '../PlayerGroupPage/PlayerGroupPage.css'; // Tell Webpack that Button.js uses these styles
import PlayerStrokeItem from '../PlayerGroupPage/PlayerStrokeItem';

import * as Constants from '../../Common/constants.js';
import * as Utils from '../../Common/utils.js';
import { ReportFeedPage } from '../ReportFeedPage/ReportFeedPage';
import MediaQuery from 'react-responsive'

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';

const useStyles = makeStyles({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
        backgroundColor: 'blue',
        color: 'yellow'
    },
    header: {
        backgroundColor: 'green',
        color: 'red'
    }
});

export default class ScoreTable extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            socketMsg: [],
            groupEvents: [],
            showData: false,
            holes: []
        };

        this.renderEventHistory = this.renderEventHistory.bind(this);
        console.info('PlayerGroupPlayer - constructor called.');
    }
    static getDerivedStateFromProps(props, state) {
        console.info('PlayerGroupPlayer - getDerivedStateFromProps called.');
        return state;
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        console.info('PlayerGroupPlayer - getSnapshotBeforeUpdate called.');
        return null;
    }



    componentDidMount() {
        console.info('PlayerGroupPlayer - componentDidMount called.');
        this.fetchCourseData();
        //this.renderEventHistory(1);


    }



    shouldComponentUpdate() {
        console.info('PlayerGroupPlayer - shouldComponentUpdate.');
        return true;
    }


    componentDidUpdate() {
    }

    componentWillUnmount() {

    }


    onChange(e) {
        console.info('PlayerGroupPlayer - onChange called.');

    }

    render() {
        console.log("RENDER TABLE PLAYER : ", this.props.data)
        let backArrow = Constants.IMAGE_SERVER + "/images/back_arrow.png";

        const groupBy = (array, key) => {
            // Return the end result
            return array.reduce((result, currentValue) => {
                // If an array already present for key, push it to the array. Else create an array and push the object
                (result[currentValue[key]] = result[currentValue[key]] || []).push(
                    currentValue
                );
                // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
                return result;
            }, {}); // empty object is the initial value for result object
        };

        if (this.state.groupEvents != null) {
            //var renderedOutput = this.state.groupEvents.map(item => <div> {item} </div>)
        }
        var classes = useStyles;
        console.info('PlayerGroupPlayer - render called.', this.props.data);
        let classname = this.props.haslastitem ? "playercontainer_active" : "playercontainer";
        let player = this.props.data;
        this.player = player;
        let ev = groupBy(this.state.groupEvents, 'strokeIndex');
        let round = player.results.length;
        this.round = round !== 0 ? round : 1;
        //let round = this.props.data.currentRound;
        console.log("PLAYESE ", player.results);


        return (<div>
            <div className="groupheaderHole"><span style={{ float: "left", marginLeft: 20, fontWeight: 100, fontSize: 10 }}>TOTAL: {player.total}</span> Hole {this.props.data.currentHole}</div>

            <div className={classname}>



                <Table >

                    <TableHead>
                        <TableRow style={{ backgroundColor: 'black', color: 'white' }}>
                            <TableCell style={{ ...styles.leaderboardheaderName, ...styles.white }}>Hole</TableCell>

                            {this.createTableHead()}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell style={styles.leaderboardheaderName}>Par</TableCell>

                            {this.createTablePar(this.state.holes)}


                        </TableRow>
                        <TableRow>
                            {/*<TableCell style={styles.leaderboardheader} align="left"><span style={{
                    paddingBottom: '10px', fontFamily: 'titling-gothic-fb-wide, sans-serif',
                    fontWeight: '100', fontStyle: 'normal', fontSize: '0.7em'
                  }}>{this.props.data.name.split(" ")[0]}</span><br></br><span style={{ fontFamily: 'titling-gothic-fb-wide, sans-serif', fontWeight: '700', fontStyle: 'normal', fontSize: '0.7em' }}>{this.props.data.name.split(" ")[1]}</span></TableCell>*/}

                            <TableCell style={styles.leaderboardheaderName}>Rnd {round}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(1)}>{player.results.length != 0 && player.results[round - 1]['hole1'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole1'], 1) : this.renderPlayerEvents(1)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(2)}>{player.results.length != 0 && player.results[round - 1]['hole1'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole2'], 2) : this.renderPlayerEvents(2)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(3)}>{player.results.length != 0 && player.results[round - 1]['hole2'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole3'], 3) : this.renderPlayerEvents(3)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(4)}>{player.results.length != 0 && player.results[round - 1]['hole3'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole4'], 4) : this.renderPlayerEvents(4)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(5)}>{player.results.length != 0 && player.results[round - 1]['hole4'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole5'], 5) : this.renderPlayerEvents(5)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(6)}>{player.results.length != 0 && player.results[round - 1]['hole5'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole6'], 6) : this.renderPlayerEvents(6)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(7)}>{player.results.length != 0 && player.results[round - 1]['hole6'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole7'], 7) : this.renderPlayerEvents(7)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(8)}>{player.results.length != 0 && player.results[round - 1]['hole7'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole8'], 8) : this.renderPlayerEvents(8)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(9)}>{player.results.length != 0 && player.results[round - 1]['hole8'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole9'], 9) : this.renderPlayerEvents(9)}</TableCell>


                        </TableRow>
                    </TableBody>
                </Table>


            </div>

            <div className={classname}>



                <Table >
                    <TableHead >
                        <TableRow style={{ backgroundColor: 'black', color: 'white' }}>
                            <TableCell style={{ ...styles.leaderboardheaderName, ...styles.white }} align="left" >Hole</TableCell>

                            {this.createTableHeadTwo()}

                        </TableRow>
                    </TableHead>
                    <TableBody >
                        <TableRow>
                            <TableCell style={styles.leaderboardheaderName} >Par</TableCell>

                            {this.createTableParTwo(this.state.holes)}


                        </TableRow>
                        <TableRow>
                            {/*<TableCell style={styles.leaderboardheader} align="left"><span style={{
        paddingBottom: '10px', fontFamily: 'titling-gothic-fb-wide, sans-serif',
        fontWeight: '100', fontStyle: 'normal', fontSize: '0.7em'
      }}>{this.props.data.name.split(" ")[0]}</span><br></br><span style={{ fontFamily: 'titling-gothic-fb-wide, sans-serif', fontWeight: '700', fontStyle: 'normal', fontSize: '0.7em' }}>{this.props.data.name.split(" ")[1]}</span></TableCell>*/}
                            <TableCell style={styles.leaderboardheaderName}  >Rnd {round}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(10)}>{player.results.length != 0 && player.results[round - 1]['hole9'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole10'], 10) : this.renderPlayerEvents(10)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(11)}>{player.results.length != 0 && player.results[round - 1]['hole10'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole11'], 11) : this.renderPlayerEvents(11)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(12)}>{player.results.length != 0 && player.results[round - 1]['hole11'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole12'], 12) : this.renderPlayerEvents(12)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(13)}>{player.results.length != 0 && player.results[round - 1]['hole12'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole13'], 13) : this.renderPlayerEvents(13)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(14)}>{player.results.length != 0 && player.results[round - 1]['hole13'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole14'], 14) : this.renderPlayerEvents(14)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(15)}>{player.results.length != 0 && player.results[round - 1]['hole14'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole15'], 15) : this.renderPlayerEvents(15)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(16)}>{player.results.length != 0 && player.results[round - 1]['hole15'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole16'], 16) : this.renderPlayerEvents(16)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(17)}>{player.results.length != 0 && player.results[round - 1]['hole16'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole17'], 17) : this.renderPlayerEvents(17)}</TableCell>
                            <TableCell style={styles.leaderboardHeaderScore} onClick={() => this.showEventData(18)}>{player.results.length != 0 && player.results[round - 1]['hole17'].result != null ? this.renderStrokeItem(player.results[round - 1]['hole18'], 18) : this.renderPlayerEvents(18)}</TableCell>

                        </TableRow>
                    </TableBody>
                </Table>


            </div>
            <div className="explanations" >
                <div class="explainMark" style={styles.leaderboardheaderScoreEagle}></div> 
                    <span class="explainText">Eagle</span> 
                <div class="explainMark" style={styles.leaderboardheaderScoreBirdie}></div> 
                    <span class="explainText">Birdie</span>  
                <div class="explainMark" style={styles.leaderboardheaderScoreBoogie}></div> 
                    <span class="explainText">Boogie</span>  
                <div class="explainMark" style={styles.leaderboardheaderScoreDBoogie}></div> 
                    <span class="explainText">Double boogie +</span>  
            </div>

            <div className="playercontainer" style={{marginTop:'30px'}}> {this.state.showData ? <div className="eventMessageContainer">{this.printEventMessages()}</div> : null} </div>
        </div>);;


    }

    createTableHead() {
        let head = [];
        for (let index = 1; index < 10; index++) {
            head.push(<TableCell key={index} style={{ textAlign: 'center', fontSize: 10, color: 'white' }} align="center">{index}</TableCell>)

        }
        return head;
    }

    createTableHeadTwo() {
        let head = [];
        for (let index = 10; index < 19; index++) {
            head.push(<TableCell key={index} align="center" style={{ textAlign: 'center', fontSize: 10, color: 'white' }}>{index}</TableCell>)

        }
        return head;
    }

    createTablePar(holes) {
        let par = [];
        for (let index = 0; index < 9; index++) {
            par.push(<TableCell key={index} style={{ textAlign: 'center', fontSize: 10 }} align="left">{holes.length > 0 && holes != undefined ? holes[index].par : null}</TableCell>)

        }
        return par;
    }

    createTableParTwo(holes) {
        let par = [];
        for (let index = 9; index < 18; index++) {
            console.log("holes", holes[index])
            par.push(<TableCell key={index} align="left" style={{ textAlign: 'center', fontSize: 10 }}>{holes.length > 0 && holes != undefined ? holes[index].par : null}</TableCell>)

        }
        return par;
    }

    createResultTable() {
        this.player.results[0].forEach(r => {
            return <TableCell onClick={() => this.showEventData(1)} align="left">{this.player.results.length != 0 && this.player.results[this.round - 1].resultHole1 != null ? this.renderStrokeItem(this.player.results[this.round - 1].resultHole1, 1) : this.renderPlayerEvents(1)}</TableCell>

        })
    }

    printEventMessages() {
        let arr = new Array();
        let obj = new Object();
        let socketItems1 = new Array();

        let resultArr = this.state.groupEvents;

        for (var i = 0; i < resultArr.length; i++) {


            if (resultArr[i].type == "STROKE") {
                //if (socketItems.length == 0) {
                //console.log("zero");
                let obj2 = new Object();
                obj2.id = resultArr[i].id;
                obj2.title = resultArr[i].strokeIndex;
                obj2.scout = "Scout " + resultArr[i].scoutId;
                obj2.event = JSON.parse(resultArr[i].data).lie;
                obj2.type = "STROKE";
                arr.push(obj2);
                obj.data = arr;
                // console.log("obj: ", obj2)
                socketItems1.push(obj2);
            } else if (resultArr[i].type == "RESULT") {
                let obj2 = new Object();
                obj2.id = resultArr[i].id;
                obj2.title = resultArr[i].strokeIndex + " - In Hole";
                obj2.scout = "Scout " + resultArr[i].scoutId;
                obj2.event = Utils.getResultAsText(JSON.parse(resultArr[i].data).result);
                obj2.type = "RESULT";
                // console.log("objs: ", JSON.parse(resultArr[i].data).result)
                socketItems1.push(obj2);

            } else if (resultArr[i].type == "TOTAL") {
                let obj2 = new Object();
                obj2.title = resultArr[i].strokeIndex;
                obj2.scout = "Official";
                // console.log("objs: ", JSON.parse(resultArr[i].data).result)
                socketItems1.push(obj2);

            }

        }

        let socketdata = socketItems1;

        socketdata = socketdata.map(item => ({
            title: item.title,
            data: this.filterData(item.title, socketdata)
        }));
        var filter_data = {};

        socketdata.forEach(e => {

            if (filter_data[e.title] != undefined) {

                filter_data[e.title].data = [...filter_data[e.title].data]
            } else {
                filter_data[e.title] = e;
            }

        });
        var _data = Object.values(filter_data);
        var ret = new Array;
        ret.push();
        for (var i = _data.length - 1; i >= 0; i--) {

            if (_data[i].title == '0 - In Hole') {
                _data[i].title = ' - In Hole';
            }

            ret.push(<div className="eventMessageStroke" key={_data[i].title} >SHOT {_data[i].title}</div>)
            console.log("REPP", _data[i])
            for (let j = 0; j < _data[i].data.length; j++) {
                ret.push(<div className="eventMessageBox" key={_data[i].data[j].id}> <div className="eventMessage" style={{ color: "white" }}><span style={{ fontSize: 13 }}>{_data[i].data[j].scout}</span><div style={{ position: "absolute", bottom: 0, marginBottom: "3px", right: 0 }}>{this.renderStrokeColor(_data[i].data[j].event)}</div></div></div>
                );

            }


        }
        console.log("RETT", _data)
        return <div><div style={{ textAlign: "center", marginBottom: "10px" }}><span style={{ color: "black", fontSize: 10, border: "1px solid gray", padding: "5px", paddingLeft: "20px", paddingRight: "20px", borderRadius: "8px" }}>Hole {this.state.currHole}</span></div><div className="messBox">{ret}</div></div>;
    }

    filterData(c, hw, set) {
        //return hw.filter(item => item.title == c );
        return hw.filter(function (item) {
            return item.title == c;
        }).map(function ({ scout, event, id }) {
            return { scout, event, id };

        });
    }


    fetchCourseData() {
        console.log("fetch tournament with id:");
        //http://134.209.230.231:8080/leaderboard/1
        let url = Constants.SERVER + "/leaderboard/" + this.props.tid; //Constants.LEADERBOARD_GSS_ID;
        fetch(url)
            .then(response => response.json())
            .then(data => {

                // var players = data.leaderboard.players;
                // var map = {};
                // players.forEach(element => {
                //     map[element.id] = element;
                // });

                // data.leaderboard.players = map;
                this.setState({ holes: data.courses[0].holes })
            }


            ).catch((error) => {
                console.log("error when fetchTournament", url);
                console.error(error);
            });;
    }
    renderStrokeColor(data) {
        let classname = "leaderBoardEventBox";
        if (data) {
            let status = data.toLowerCase();

            if (status.includes("green")) {
                classname += " green";
            } else if (status.includes("sand")) {
                classname += " sand";
            } else if (status.includes("preparing")) {
                classname += " prepare blink_me";
            } else if (status.includes("ruff")) {
                classname += " ruff";
            } else if (status.includes("water")) {
                classname += " water";
            } else if (status.includes("fairway")) {
                classname += " fairway";
            }
        }

        //return (<div className = "playerEventbox">{{status}}</div>)
        // return (<div className="strokeitem"><div className="strokeitemnum">{data.strokeIndex}</div><div className="playerEventbox">{status}</div></div>);
        return (<div className={classname}><p>{data}</p></div>);



    }



    showEventData(holeindex) {
        this.setState({ currHole: holeindex })
        if (holeindex == this.props.hole) {
            this.renderSocketEvents(holeindex);
        } else {

            this.renderEventHistory(holeindex)
        }

        let that = this;
        setTimeout(function () {
            //console.log("POLKA", that.state.groupEvents);

            that.setState({ showData: true })

        }, 330);
    }
    renderSocketEvents(holeindex) {
        var events = [];
        let tempArr = new Array();


        //let holeindex = Utils.getHoleIndex(this.props.data);
        if (this.props.data.events) {
            events = this.props.data.events;
            //console.log("SCOUTEVENTS!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!: ", this.props.data.events);

        }
        for (var i = events.length - 1; i >= 0; i--) {
            /*if(events[i].type == "STROKE" || events[i].type == "RESULT"){
              tempArr.push(events[i]);
      
            }*/
        }
        //events = tempArr;
        let lastid = events.length > 0 ? events[events.length - 1].id : -1;


        let scoutevents = this.props.leaderboard.leaderboard ? this.props.leaderboard.leaderboard.events : null;
        if (scoutevents) {
            scoutevents.forEach(element => {
                //console.log("SOCKETTT", element);
                if ("" + element.holeIndex === holeindex && element.playerId === this.props.data.id &&
                    element.id > lastid) {
                    events.push(element);
                }
            });
        }

        if (holeindex == this.props.hole) {
            this.setState({
                groupEvents: events
            })
        }

    }

    renderPlayerInfo() {
        let name = this.props.data.name.split(" ")[0];
        let lastName = this.props.data.name.split(" ")[1]
        return (<div className="playerheader" onClick={this.props.onclick} >
            <div className="playerGroupPosition" style={{ borderColor: this.props.data.color }}>
                {this.props.data.total}
            </div> <div className="playername" >{name}<br></br><span style={{ fontWeight: '800' }}>{lastName}</span></div>
            {/*<ReportFeedPage leaderboard1={this.props.leaderboard.leaderboard}></ReportFeedPage>*/}
        </div>);

    }


    loadGroupResults(holeindex) {
        console.log("Load Player Events");
        var url = Constants.SERVER + "/grouptable/" + this.props.data.id + "/" + holeindex;
        var component = this;
        fetch(url)
            .then(function (response) {
                return response.json();
            })
            .then(function (playerevents) {
                console.log("Load Player setState", playerevents);


            });

    }

    renderEventHistory(holeIndex) {

        let url = Constants.SERVER + "/playerevent?playerId=" + this.props.data.id + "&roundIndex=" + this.props.data.currentRound + "&holeIndex=" + holeIndex;
        //let url = Constants.SERVER + "/grouptable/"+this.props.gid;
        let temparr = new Array();
        let resultArr = new Array();

        console.log("loadPlayerFromBackend", url);
        fetch(url, {
            method: 'GET'
        })
            .then((response) => response.json())
            .then((responseJson) => {

                // this.setState({socketMsg: [ this.state.socketMsg, responseJson]})
                // this.setState({groupEvents: responseJson})
                temparr = responseJson;
                if (temparr != undefined) {
                    for (var i = temparr.length - 1; i >= 0; i--) {
                        if (temparr[i].type == "STROKE" || temparr[i].type == "RESULT" || temparr[i].type == "TOTAL") {
                            console.log("TEMPPP", temparr[i].scoutId);
                            resultArr.push(temparr[i]);

                        }
                    }

                }
                // return responseJson[0].type;
            })
            .catch((error) => {
                console.log("error when loadPlayerFromBackend", url);
                console.error(error);
            });


        this.setState({ groupEvents: resultArr })

    }


    renderStrokeItem(res, index) {
        let result = res.result;
        if (this.state.holes[index - 1] !== undefined) {
            let par = this.state.holes[index - 1].par;
            //let result = getStrokeResult(res);

            return <div className="leaderBoardEventBo" style={{ position: 'relative', height: 20 }} >
                <span style={res.confirmationLevel === 'TOUR' ? styles.tourConfirmed : res.confirmationLevel === 'CROWD' ? styles.crowdConfirmed : null}></span>
                
                <p style={result === -1 ? styles.leaderboardheaderScoreBirdie : result === 1 
                    ? styles.leaderboardheaderScoreBoogie : result === -2 
                    ? styles.leaderboardheaderScoreEagle : result >= 2 
                    ? styles.leaderboardheaderScoreDBoogie : 
                    styles.leaderboardheaderPar}>{result !== null ? par + result : null}</p>
            </div>
        }
    }

    renderPlayerEvents(holeindex) {
        var events = [];

        if (this.props.data.events) {
            events = this.props.data.events;

        }

        let lastid = events.length > 0 ? events[events.length - 1].id : -1;


        let scoutevents = this.props.leaderboard.leaderboard ? this.props.leaderboard.leaderboard.events : null;
        if (scoutevents) {
            scoutevents.forEach(element => {
                if ("" + element.holeIndex === holeindex && element.playerId === this.props.data.id &&
                    element.id > lastid && (element.type == "STROKE" || element.type == "RESULT")) {
                    events.push(element);
                }
            });
        }
        if (holeindex == this.props.hole) {
            /* this.setState({
               groupEvents : events
             })*/
        }

        this.props.data.events = events;
        let items = [];


        if (!events || events.length == 0) {
            items.push(<PlayerStrokeItem data={null} key={0} />);
            return items;
        }
        var lastEventPerStroke = new Object();
        var mapStrokeIndex = 1;
        events.forEach(element => {
            lastEventPerStroke[element.strokeIndex] = element;
            mapStrokeIndex = element.strokeIndex;
        });

        for (let index = 1; index <= mapStrokeIndex; index++) {
            const element = lastEventPerStroke[index];
            if (element !== undefined) {
                if (element.holeIndex == holeindex && index == mapStrokeIndex) {
                    items.push(<PlayerStrokeItem data={element} key={index} />);
                }
            }


        }

        return items;
    }
    renderPlayerStrokesInfo() {
        let items = this.renderCurrentHoleStrokeItems();

        return (<div>
            {items}
        </div>
        );
    }

    renderCurrentHoleStrokeItems() {
        let array = [];
        let currentholeevents = [];
        let maxstrokeindex = 0;
        let currenthole = this.props.data.currenthole;
        let mapStrokeIndex = new Object();
        this.props.data.events.forEach(e => {
            if (e.holeindex === currenthole) {

                currentholeevents.push(e);
                maxstrokeindex = Math.max(e.strokeindex, maxstrokeindex);

                var a = mapStrokeIndex[e.strokeindex];

                if (!a) {
                    a = [];
                }

                a.push(e);

                mapStrokeIndex[e.strokeindex] = a;

            }
        });

        for (let index = 0; index < maxstrokeindex; index++) {

            const a = mapStrokeIndex[index + 1];
            array.push(<PlayerStrokeItem data={a} key={index} />);

        }

        if (currentholeevents.length === 0) {
            array.push(<PlayerStrokeItem key={0} />);
        }

        return array;
    }
    getCurrentStrokeData() {
        var currentstroke = new Object();
        currentstroke.index = 1;
        currentstroke.status = "Preparing to hit";
        return currentstroke;
    }



}
function getStrokeResult(result) {
    var str = "in CUP - ";
    if (result == 0) {
        return "Par";
    } else if (result == 1) {
        return "Bogey";
    } else if (result == 2) {
        return "Double Bogey";
    }
    else if (result == 3) {
        return "Tripple Bogey";
    } else if (result == -1) {
        return "Birdie";
    } else if (result == -2) {
        return "Eagle";
    } else {
        return "OTHER (" + result + ")";
    }
}
const emptyStyle = {

    'textAlign': 'center',
    'margin': '0 auto'
};

const styles = {
    crowdConfirmed: {
        'height': '10px',
        'width': '10px',
        'borderRadius': '50%',
        'backgroundColor': '#faca9c',
        'position': 'absolute',
        'left': 0,
        'top': '-15px',

    },
    tourConfirmed: {
        'height': '6px',
        'width': '6px',
        'borderRadius': '50%',
        'backgroundColor': '#a5f4a5',
        'position': 'absolute',
        'left': '-4',
        'top': '-14px',


    },
    leaderboardheader: {
        'borderRightWidth': 'thin',
        'borderRightColor': 'rgb(241, 241, 241)',
        'borderRightStyle': 'solid'

    },
    leaderboardheaderPar: {
        'textAlign': 'center',

    },
    leaderboardHeaderScore: {
        'width': '20px',
        'height': '10',
        'fontSize': '10px',
        'fontWeight': '400',

    },
    leaderboardName: {

        'textAlign': 'left',
        'fontWeight': '400',
        'marginLeft': '20px',
        'marginRight': '20px',
        'position': 'absolute',
        'bottom': '0',
        'marginBottom': '40px',
    },
    leaderboardheaderName: {
        'width': '20px',
        'marginBottom': '3px',
        'fontWeight': '900',
        'lineHeight': '10px',
        'textAlign': 'center',
        'fontSize': '10px'
    },
    leaderboardheaderPos: {
        'width': '5%'
    },
    white: {
        'color': 'white',
        'fontStyle': 'italic',
        'fontWeight': '100',
        'fontSize': '12px',
    },
    /* leaderboardheaderScore:{
       'width' : '10%',
       'borderRightWidth': 'thin' ,
       'borderRightColor' : 'rgb(241, 241, 241)',
       'borderRightStyle' :'solid',
       'textAlign':'center',
       'fontWeight': '400',
       'fontFamily': 'titling-gothic-fb-skyline, sans-serif',
       'fontSize' : '2em'
     },*/
    leaderboardheaderScoreBirdie: {
        /* 'border': 'solid red',
         'borderWidth':'2px',*/
        'borderRadius': '50%',
        'color': 'white',
        'backgroundColor': 'red',
        'width': '15px',
        'height': '15px',
        'lineHeight': '15px',
        'textAlign': 'center',
        'marginLeft': 'auto',
        'marginRight': 'auto'
    },
    leaderboardheaderScoreBoogie: {
        'backgroundColor': 'black',
        'borderWidth': '2px',
        'width': '15px',
        /* text-align: center; */
        'textAlign': 'center',
        'marginLeft': 'auto',
        'marginRight': 'auto',
        'lineHeight': '15px',
        'height': '15px',
        'color': 'white',

    },
    leaderboardheaderScoreDBoogie: {
        'backgroundColor': '#376994',
        'borderWidth': '2px',
        'width': '15px',
        /* text-align: center; */
        'textAlign': 'center',
        'marginLeft': 'auto',
        'marginRight': 'auto',
        'lineHeight': '15px',
        'height': '15px',
        'color': 'white',

    },
    leaderboardheaderScoreEagle: {
        'backgroundColor': 'yellow',
        'borderRadius': '50%',
        'borderWidth': '2px',
        'width': '15px',
        'lineHeight': '15px',
        'height': '15px',
        'textAlign': 'center',
        /* text-align: center; */
        'marginLeft': 'auto',
        'color': 'white',
        'marginRight': 'auto',
    },
    leaderboardheaderHole: {
        'cursor': 'pointer',
        'minWidth': '50px',
        'borderRightWidth': 'thin',
        'borderRightColor': 'rgb(241, 241, 241)',
        'borderRightStyle': 'solid',
        'textAlign': 'center',
        'fontWeight': '400',
        'fontFamily': 'titling-gothic-fb-skyline, sans-serif',
        'fontSize': '2em'
    }
}




// WEBPACK FOOTER //
// ./src/Components/Leaderboard/ScoreTable.js